var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemSingleChoice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M13 6h7a1 1 0 0 1 0 2h-7a1 1 0 1 1 0-2m-3 12h10a1 1 0 0 1 0 2H10a1 1 0 1 1 0-2m0-6h10a1 1 0 0 1 0 2H10a1 1 0 1 1 0-2m-.164-8.747a1 1 0 0 1 1.328 1.494l-4.5 4a1 1 0 0 1-1.371-.04l-2-2a1 1 0 1 1 1.414-1.414L6.04 6.625zM6 17a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0-6a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
})));
export default SvgGemSingleChoice;